import { createContext, type ReactNode, useContext, useMemo } from 'react'

import {
  type MyCurrentAccountQuery,
  useMyCurrentAccountQuery,
} from '@/__generated__/hooks'

type CurrentAccount = NonNullable<MyCurrentAccountQuery['myCurrentAccount']>

const CurrentAccountContext = createContext<CurrentAccount | null>(null)

export const useCurrentAccount = (): CurrentAccount | null =>
  useContext(CurrentAccountContext)

export const useCurrentAccountStrict = (): CurrentAccount => {
  const ctx = useCurrentAccount()
  if (!ctx) {
    throw new Error(
      'useCurrentAccountStrict requires an active account. Wrap the route in <AuthGuard> which redirects to /account-select when missing.'
    )
  }
  return ctx
}

type Props = { children: ReactNode }

const CurrentAccountProvider = ({ children }: Props) => {
  const { data } = useMyCurrentAccountQuery()
  const value = useMemo(() => data?.myCurrentAccount ?? null, [data])

  return (
    <CurrentAccountContext.Provider value={value}>
      {children}
    </CurrentAccountContext.Provider>
  )
}

export default CurrentAccountProvider
